import { render, staticRenderFns } from "./identify.vue?vue&type=template&id=7b54242f&scoped=true&"
import script from "./identify.vue?vue&type=script&lang=js&"
export * from "./identify.vue?vue&type=script&lang=js&"
import style0 from "./identify.vue?vue&type=style&index=0&id=7b54242f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b54242f",
  null
  
)

export default component.exports